import { createContext, useState } from "react";

export const SidePaneContext = createContext();

export const SidePaneProvider = ({ children }) => {
	const [SidePaneContent, setSidePaneContent] = useState(null);

	return <SidePaneContext.Provider value={{ SidePaneContent, setSidePaneContent }}>{children}</SidePaneContext.Provider>;
};
